export default function (ModalService) {
    return function (notes) {
        return ModalService.showModal({
            controller: require('../../controllers/notes/list/noteListCtrl'),
            template: require('../../controllers/notes/list/notes-list.html'),
            controllerAs: 'nodesList',
            inputs: {
                notes
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/notes/openListNoteModal.js